import { FormSelectInline } from '@systemeio/ui'
import { useEmailList } from 'modules/profile/mailing-settings/hooks/use-email-list'
import { EmailItemInterface } from 'modules/profile/mailing-settings/types/email-list-interface'
import { FC, useEffect, useState } from 'react'
import { CopyToClipboardButton } from 'shared/components/copy-to-clipboard-button'

interface DmarcProps {
  isReady: boolean
}

export const DMARC_KEY = '_dmarc'

const DMARC_STATIC = 'v=DMARC1; p=none; rua=mailto:'

const Dmarc: FC<DmarcProps> = ({ isReady }) => {
  const { data: emailList } = useEmailList(isReady)
  const [emailItem, setEmailItem] = useState<EmailItemInterface | undefined>()
  const selectData = emailList?.map(email => ({ id: email.id, caption: email.email }))
  const dmarc = DMARC_STATIC + emailItem?.email

  useEffect(() => {
    if (emailList && emailList.length > 0) {
      setEmailItem(emailList[0])
    }
  }, [emailList])
  return (
    <div className={'flex w-full select-none items-center'}>
      <span>{DMARC_STATIC}</span>
      <FormSelectInline
        value={emailItem?.id}
        onChange={data => {
          if (emailList) {
            const selectedEmail = emailList.find(email => email.id === data)
            setEmailItem(selectedEmail)
          }
        }}
        data={selectData}
        withoutCloseIcon
        arrowButtonClassName={'h-[20px]'}
      />
      <CopyToClipboardButton
        className={'[&_svg]:fill-brand-primary/70 ml-1.5'}
        text={dmarc}
        disabled={!emailItem}
      />
    </div>
  )
}

export default Dmarc
